import { render } from "./tasks-page.vue?vue&type=template&id=18603f63"
import script from "./tasks-page.vue?vue&type=script&lang=js"
export * from "./tasks-page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__